import React from 'react';
import Table from '../../components/common/Table';
import { ExerciseTypeDTO } from '../../services/apiClient';
import { renderBooleanBadge } from '../../utils/displayUtils';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';

interface ExerciseTypeTableProps {
  data: any[];
  handleEdit: (service: any) => void;
  handleDelete: (service: any) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const ExerciseTypeTable: React.FC<ExerciseTypeTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: "Title",
          key: "title",
        },
        {
          label: "Postal",
          key: "isPostal",
          render: (row: ExerciseTypeDTO) => renderBooleanBadge(row.isPostal ?? false),
        },
        {
          label: "Competition",
          key: "isCompetition",
          render: (row: ExerciseTypeDTO) => renderBooleanBadge(row.isCompetition ?? false),
        },
        {
          label: "Active",
          key: "isActive",
          render: (row: ExerciseTypeDTO) => renderBooleanBadge(row.isActive ?? false),
        },
        {
          label: "DisplayPosition",
          key: "displayPosition",
        },
        {
          label: "Added",
          key: "createdUtc",
          format: (createdUtc: Date) => convertToUserTime(createdUtc?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default ExerciseTypeTable;
